module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAQ1JREFUOI3NkjFLBDEQhd/zwOp+gD/ELgQOeyu7w85Cwcomswhy2wibFNdc47UW2tlaqpDdH3E/ZsdmBTmS7G0jTpW8eXzzmIQolHPugeQtAKjqJoTwmPPOcg0RWZO8BzAHMCd5Zq2dxRg/Uv6jQqDLfUFVr3LmEiiV9ngyiORLQn6eMhUAEGN8N8ackDwdpI33/i7nHy0RURHRMV9pR5Pqb0DOuVXqnKrssquqqgHUP3eSC2stY4yfB4OG6TUA9H1/rqqvJJcAFsYYtG37NQpyzq1I1kOKZQjhreu6nbV2B+CCZBLGwtPeeO+3vwURuQbwlDInl02y2ocAgPd+S7I6GNQ0jc+kzPb+34f8BurOVjLPEV2/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/device_hub_24pxworkflow.png
// module id = ./src/_asset/sources/assets/images/device_hub_24pxworkflow.png
// module chunks = main